import { authentication } from '@kiroku/api';

export function useProfile() {
    const { user } = authentication.useAuthenticatedContext();
    return [user];
}
